<template>
  <v-row justify="center">
    <v-dialog persistent v-model="dialog" max-width="80%">
      <template v-slot:activator="{ on, attrs }">
        <v-btn class="responsive-button" height="80px" width="80%" v-if="bottomStyle" color="primary" v-bind="attrs" v-on="on">
          Crear Asignatura
        </v-btn>
        <v-btn class="responsive-button" v-else text block v-bind="attrs" v-on="on">
          Crear Asignatura
        </v-btn>
      </template>

      <v-container fluid>
        <v-card >
          <v-card-title class="primary white--text">Crear una asignatura</v-card-title>

          <v-form @submit.prevent="submit" ref="form" lazy-validation>
            <v-card-text>
              <v-row justify="center" align="center">
                <v-col cols="12">
                  <v-text-field
                    v-model="form.name"
                    prepend-icon="mdi-format-title"
                    label="Nombre Asignatura"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="form.year"
                    type="number"
                    prepend-icon="mdi-calendar"
                    label="Año"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-select
                    v-model="form.period"
                    :items="period"
                    prepend-icon="mdi-calendar-check-outline"
                    label="Periodo"
                    required
                  ></v-select>
                </v-col>
                <v-col cols="12">
                  <v-textarea
                    prepend-icon="mdi-format-text-variant-outline"
                    v-model="form.description"
                    auto-grow
                    filled
                    color="deep-purple"
                    label="Breve Descripción"
                    rows="3"
                  ></v-textarea>
                </v-col>
                <v-col cols="12">
                  <v-file-input
                    v-model="form.image"
                    accept="image/*"
                    placeholder="Seleccione una Imagen"
                    prepend-icon="mdi-camera"
                    label="Imagen (Opcional)"
                    show-size
                  ></v-file-input>
                </v-col>
                
                <!-- Vista previa de la imagen si está seleccionada -->
                <v-col v-if="imagePreview" cols="12" class="text-center">
                  <v-img
                    :src="imagePreview"
                    max-height="200"
                    contain
                    class="mx-auto"
                  ></v-img>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions class="mx-2">
              <v-btn color="error" @click="cancel"> Cancelar </v-btn>
              <v-spacer></v-spacer>
              <v-btn color="primary" type="submit" :loading="loading">
                Crear Asignatura
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
        
        <v-snackbar class="text-center" :color="color" v-model="snackbar">
          {{ text }}

          <template v-slot:action="{ attrs }">
            <v-btn text v-bind="attrs" @click="snackbar = false"> OK </v-btn>
          </template>
        </v-snackbar>
     
      </v-container>
      
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  props: {
    bottomStyle: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      snackbar: false,
      text: "",
      color: "",
      dialog: false,
      loading: false,
      period: ["Anual", "Semestral", "Trimestral"],
      form: {
        name: "",
        year: null,
        period: "",
        description: "",
        image: null,
      },
      imagePreview: null,
    };
  },
  watch: {
    'form.image': function(newFile) {
      if (newFile) {
        this.createImagePreview(newFile);
      } else {
        this.imagePreview = null;
      }
    }
  },
  methods: {
    createImagePreview(file) {
      if (!file) return;
      
      const reader = new FileReader();
      reader.onload = (e) => {
        this.imagePreview = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    
    resetForm() {
      this.form = {
        name: "",
        year: null,
        period: "",
        description: "",
        image: null,
      };
      this.imagePreview = null;
    },

    async submit() {
      if (
        this.form.name === "" ||
        this.form.period === "" ||
        this.form.description === "" ||
        this.form.year === null
      ) {
        this.setSnackBar("red", "Debe rellenar todos los campos", true);
        return;
      }

      if (this.form.year === "" || (this.form.year < 1000 || this.form.year > 3000)) {
        this.setSnackBar("red", "Ingrese bien la fecha, tiene que ser un año coherente", true);
        return;
      }
      
      this.loading = true;
      
      // Crear FormData para enviar la imagen, siguiendo el patrón de createText
      const formData = new FormData();
      
      // Añadir todos los campos al FormData
      Object.keys(this.form).forEach(key => {
        if (key === 'image') {
          // Solo añadir la imagen si es un archivo válido
          if (this.form.image instanceof File) {
            formData.append('image', this.form.image);
          }
        } else {
          // Para el resto de campos, añadirlos directamente
          const value = this.form[key] === null ? '' : this.form[key];
          formData.append(key, value);
        }
      });

      try {
        await this.$store.dispatch("teacher/createLesson", formData);
        this.setSnackBar("green", "Asignatura creada con éxito", true);
        this.resetForm();
      } catch (error) {
        console.error("Error details:", error.response ? error.response.data : error);
        const errorMsg = error.response?.data?.error || `Error: ${error.message}`;
        this.setSnackBar("red", errorMsg, true);
      } finally {
        this.loading = false;
      }
    },

    setSnackBar(color, text, snack) {
      this.color = color;
      this.text = text;
      this.snackbar = snack;
    },

    cancel() {
      this.resetForm();
      this.dialog = false;
    },
  },
};
</script>